<script setup>
import {useSystem} from "../../store/system";
import {useRoute, useRouter} from "vue-router";

const router = useRouter()
const systemStore = useSystem()
const jumpMenu = (index) => {
  systemStore.currentShortMenu = index
  if (index === 1) {
    router.push({path: '/'})
  }
  if (index === 2) {
    router.push({path: '/Products'})
  }
  if (index === 3) {
    router.push({path: '/Dashboard'})
  }
  if (index === 4) {
    router.push({path: '/BecomePromoter'})
  }
  if (index === 5) {
    router.push({path: '/APP'})
  }
}
</script>

<template>

  <!--  手机底部快捷导航-->
  <div v-if="systemStore.getIsMobile" class="fixed-bottom !tw-left-0 tw-w-[100vw] tw-z-[999] tw-p-[10px] tw-bg-[#16142A]" style="border-top: 1px solid rgba(255,255,255, 0.5)">
    <div class="tw-flex tw-justify-around tw-items-center tw-text-white tw-text-center tw-text-[12px]">
      <div @click="jumpMenu(1)" :class="systemStore.currentShortMenu === 1? 'text-purple-500': ''">
        <i class="ti ti-home tw-text-[25px]"></i>
        <div>Home</div>
      </div>
      <div @click="jumpMenu(2)" :class="systemStore.currentShortMenu === 2? 'text-purple-500': ''">
        <i class="ti ti-box tw-text-[25px]"></i>
        <div>Plans</div>
      </div>
      <div @click="jumpMenu(3)" :class="systemStore.currentShortMenu === 3? 'text-purple-500': ''">
        <div class="tw-bg-purple-900 tw-p-3 tw-rounded-full tw-relative tw-top-[-2rem]">
          <i class="ti ti-category tw-text-[25px]"></i>
        </div>
      </div>
      <div @click="jumpMenu(4)" :class="systemStore.currentShortMenu === 4? 'text-purple-500': ''">
        <i class="ti ti-users tw-text-[25px]"></i>
        <div>Affiiate</div>
      </div>
      <div @click="jumpMenu(5)" :class="systemStore.currentShortMenu === 5? 'text-purple-500': ''">
        <i class="ti ti-help-hexagon tw-text-[25px]"></i>
        <div>APP</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.footer__logo img{
  height: 80px;
}
</style>
